import { render, staticRenderFns } from "./ProductRankTable.vue?vue&type=template&id=61d5fca7"
import script from "./ProductRankTable.vue?vue&type=script&lang=js"
export * from "./ProductRankTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/zippo-mdm-vue-prd/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61d5fca7')) {
      api.createRecord('61d5fca7', component.options)
    } else {
      api.reload('61d5fca7', component.options)
    }
    module.hot.accept("./ProductRankTable.vue?vue&type=template&id=61d5fca7", function () {
      api.rerender('61d5fca7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/ProductRankTable.vue"
export default component.exports